import React from "react";
import { CloudDownloadOutlined, CloudUpload } from "@mui/icons-material";
import { Box } from "@mui/material";

import { StackedNavigationButton, SvgIcon, useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

interface MuPowerBoundaryPanelProps {
  hasBoundary: boolean;
}

const MuPowerBoundaryPanel: React.FC<MuPowerBoundaryPanelProps> = ({ hasBoundary }: MuPowerBoundaryPanelProps) => {
  const { open, clear } = useStackedNavigationContext();

  return (
    <Box>
      <StackedNavigationHeader title="Boundary" onBackButtonClick={clear} />
      <StackedNavigationButton
        data-testid="draw-new-polygon-button"
        icon={<SvgIcon icon="polygon" />}
        title="Draw boundary"
        subtitle="Draw your own boundary on the map"
        onClick={() => open("mu-boundary-draw")}
      />
      <StackedNavigationButton
        data-testid="upload-boundary-button"
        icon={<CloudUpload />}
        title="Upload"
        subtitle="Upload your own boundary"
        onClick={() => open("mu-boundary-upload")}
      />
      <StackedNavigationButton
        data-testid="import-button"
        icon={<CloudDownloadOutlined />}
        title="Import associated data"
        subtitle="Import data based on your boundary"
        onClick={() => open("mu-boundary-import")}
        disabled={!hasBoundary}
      />
    </Box>
  );
};

export default MuPowerBoundaryPanel;
